import { useEffect, useCallback, useState } from 'react';

interface IUseDesktopContextMenuParams {
  elementRef: React.RefObject<HTMLElement | null>;
  isMenuEnabled?: boolean;
  onShowContextMenu: (event: MouseEvent) => boolean;
  onHideContextMenu: VoidFunction;
}

export const useDesktopContextMenu = ({
  elementRef,
  isMenuEnabled = true,
  onHideContextMenu,
  onShowContextMenu,
}: IUseDesktopContextMenuParams) => {
  const [anchorPoint, setAnchorPoint] = useState({ x: 0, y: 0 });
  const [show, setShow] = useState(false);

  const handleContextMenu = useCallback(
    (event: MouseEvent) => {
      event.preventDefault();
      setAnchorPoint({ x: event.pageX, y: event.pageY });
      setShow(onShowContextMenu(event));
    },
    [setShow, setAnchorPoint, onShowContextMenu],
  );

  const closeContextMenu = useCallback(() => {
    setShow(false);
    onHideContextMenu();
  }, [onHideContextMenu]);

  useEffect(() => {
    const element = elementRef.current;

    if (!element || !isMenuEnabled) {
      return () => {};
    }

    element.addEventListener('contextmenu', handleContextMenu);

    return () => element.removeEventListener('contextmenu', handleContextMenu);
  }, [elementRef, handleContextMenu, isMenuEnabled]);

  return { anchorPoint, show, closeContextMenu };
};
